import { supabase } from "./supabase";

function urlBase64ToUint8Array(value: string): Uint8Array<ArrayBuffer> {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((character) => character.charCodeAt(0)));
}

export async function enablePushNotifications(
  ownerId: string,
): Promise<void> {
  const publicKey = import.meta.env.VITE_WEB_PUSH_PUBLIC_KEY as
    | string
    | undefined;
  if (!publicKey) {
    throw new Error("VITE_WEB_PUSH_PUBLIC_KEY is not configured");
  }
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    throw new Error("This browser does not support Web Push");
  }
  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("Notification permission was not granted");
  }
  const pendingRegistration = await navigator.serviceWorker.register(
    "/service-worker.js",
  );
  const registration = pendingRegistration.active
    ? pendingRegistration
    : await navigator.serviceWorker.ready;
  const existing = await registration.pushManager.getSubscription();
  const subscription =
    existing ??
    (await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    }));
  const json = subscription.toJSON();
  if (!json.endpoint || !json.keys?.p256dh || !json.keys.auth) {
    throw new Error("The browser returned an incomplete push subscription");
  }
  const { error } = await supabase.from("push_subscriptions").upsert(
    {
      owner_id: ownerId,
      endpoint: json.endpoint,
      p256dh: json.keys.p256dh,
      auth: json.keys.auth,
      user_agent: navigator.userAgent,
    },
    { onConflict: "owner_id,endpoint" },
  );
  if (error) {
    throw error;
  }
}
